import React from 'react';
import { DATA } from '../data/urunler-data';
import { HeaderDATA } from '../data/header-data';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  // useTranslation hook'u ile t fonksiyonunu ve mevcut dili alıyoruz.
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language; // örneğin, "tr" veya "en"
  const logoSrc = currentLanguage === 'en' ? '/images/en-logo.svg' : '/images/logo.svg';

  return (
    <div className="lg:bottom-0 -z-10">
      <div className="w-full grid grid-cols-14 bg-[#EBEBEB] py-20">
        <div className="col-start-2 col-span-12 grid grid-cols-3 gap-20">
          {/* Sol sütun: Logo, adres, telefon, mail gibi iletişim bilgileri */}
          <div className="col-span-3 md:col-span-1 flex flex-col justify-between interFont text-16">
           <Link to={'/'}>      <img
        src={logoSrc}
        className="w-48 mb-20"
        alt={t('footer.logoAlt')}
      /></Link>
            <div className="font-extralight">
              <div className="space-y-2 mb-5">
                <div className="flex items-center customHover2">
                  <img
                    src="/images/icons/location.svg"
                    className="w-4 object-contain mr-2"
                    alt="location"
                  />
                  <a
                    href="https://maps.app.goo.gl/WeqHLSssyQa7gpuV6"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {t('footer.address1')}
                  </a>
                </div>
                <div className="flex items-center customHover2 !mb-10">
                  <img
                    src="/images/icons/tel.svg"
                    className="w-4 object-contain mr-2"
                    alt="tel"
                  />
                  <a href="tel:02582635655" target="_blank" rel="noreferrer">
                    {t('footer.phone1')}
                  </a>
                </div>
                <div className="flex items-center customHover2">
                  <img
                    src="/images/icons/location.svg"
                    className="w-4 object-contain mr-2"
                    alt="location"
                  />
                  <a
                    href="https://maps.app.goo.gl/dsUurVB8EQEh6e2a7"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {t('footer.address2')}
                  </a>
                </div>
                <div className="flex items-center customHover2 !mb-10">
                  <img
                    src="/images/icons/tel.svg"
                    className="w-5 object-contain mr-2"
                    alt="tel"
                  />
                  <a href="tel:02582691095" target="_blank" rel="noreferrer">
                    {t('footer.phone2')}
                  </a>
                </div>
                <div className="flex items-center customHover2">
                  <img
                    src="/images/icons/mail.svg"
                    className="w-4 object-contain mr-2"
                    alt="mail"
                  />
                  <a href="mailto:proje@gokdelen.com.tr">
                    proje@gokdelen.com.tr
                  </a>
                </div>
              </div>
              {/* Gerekirse ek bağlantılar eklenebilir */}
            </div>
          </div>

          {/* Orta sütun: HeaderDATA ve DATA içeriği */}
          <div className="col-span-3 md:col-span-2">
            <div className="w-full grid grid-cols-2 lg:grid-cols-4 gap-5 mb-20">
              {HeaderDATA.map((item, index) => {
                return (
                  <div key={index} className="interFont text-16">
                    {/* HeaderDATA içindeki başlık artık nesne olarak tanımlı, dolayısıyla mevcut dil değerine göre gösteriyoruz */}
                    <Link
                      to={item.link}
                      className="font-medium opacity-60 hover:opacity-100 transition-all duration-300"
                    >
                      {item.title[currentLanguage]}
                    </Link>
                    <div>
                      {item.dropDown.map((subItem, subIndex) => {
                        return (
                          <Link
                            key={subIndex}
                            to={subItem.link}
                            className="font-light opacity-60 hover:opacity-100 transition-all duration-300 block"
                          >
                            {subItem.title[currentLanguage]}
                          </Link>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="w-full grid lg:grid-cols-2">
              <div className="grid grid-cols-2 lg:grid-cols-2 gap-5 content-between">
                {DATA.map((item, index) => {
                  return (
                    <div key={index} className="interFont text-16">
                      <Link to={item.link ? `/sistemler/${item.link}` : ''}>
                        <h6 className="font-medium opacity-60 hover:opacity-100 transition-all duration-300">
                          {item.name[currentLanguage]}
                        </h6>
                      </Link>
                      <div>
                        {item?.innerCategory?.map((innerCategory, innerIndex) => {
                          return (
                            <Link
                              key={innerIndex}
                              to={`/sistemler/${item.link}/${innerCategory.link}`}
                              className="font-light opacity-60 hover:opacity-100 transition-all duration-300 block"
                            >
                              {innerCategory.name[currentLanguage]}
                            </Link>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Sağ sütun: Sosyal medya ve diğer logolar */}
          <div className="w-full col-span-3 grid grid-cols-3 gap-20">
            <div className="flex flex-col-reverse md:flex-row items-start md:space-x-5 col-span-3 md:col-span-1">
              <div className="flex space-x-5">
                <a
                  href="https://www.instagram.com/gokdeleniskelekalip/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="/images/header/i.svg"
                    className="cursor-pointer customHover w-7"
                    alt="Instagram"
                  />
                </a>
                <a
                  href="https://www.facebook.com/gokdeleniskelekalip"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="/images/header/f.svg"
                    className="cursor-pointer customHover w-7"
                    alt="Facebook"
                  />
                </a>
                <a
                  href="https://www.linkedin.com/company/10594998/admin/dashboard/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="/images/header/li.svg"
                    className="cursor-pointer customHover w-7"
                    alt="LinkedIn"
                  />
                </a>
                <a
                  href="https://www.youtube.com/@gokdeleniskelekalp3165"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="/images/header/y.svg"
                    className="cursor-pointer customHover w-7"
                    alt="YouTube"
                  />
                </a>
              </div>
              <div className="mb-3 md:mb-0">{t('footer.followUs')}</div>
            </div>

            <div className="col-span-3 md:col-span-1 gap-5 grid grid-cols-2 md:grid-cols-3">
              <img
                src="/images/footer/01.png"
                className="h-10 w-full object-contain"
                alt="Moka"
              />
              <img
                src="/images/footer/02.png"
                className="h-10 w-full object-contain"
                alt="Moka Light"
              />
              <img
                src="/images/footer/03.png"
                className="h-10 w-full object-contain"
                alt="Moka"
              />
              <img
                src="/images/footer/04.png"
                className="h-10 w-full object-contain"
                alt="Moka"
              />
                     <img
                src="/images/footer/05.png"
                className="h-10 w-full object-contain"
                alt="Moka"
              />
                                  <img
                src="/images/footer/06.jpg"
                className="h-10 w-full object-contain"
                alt="Moka"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Alt kısım: Telif hakkı ve diğer bilgiler */}
      <div className="h-16 w-full bg-[#242424] grid grid-cols-14">
        <div className="col-start-2 col-span-12 flex justify-between items-center text-12 font-extralight text-white">
          <p>{t('footer.copyright')}</p>
          {/* <p>{t('footer.dealers')}</p> */}
        </div>
      </div>
    </div>
  );
};

export default Footer;
